import {
  ChatRefFragment,
  ChatsQuery,
  StandardListHookOptions,
  useChatsQuery,
  withStandardListHook,
} from '@spotify/confidence-graphql';

export type UseChatsOptions = StandardListHookOptions;

const useChatsImpl = withStandardListHook<ChatsQuery, ChatRefFragment, 'chats'>(
  useChatsQuery,
  'chats',
);

export const useChats: typeof useChatsImpl = (options = {}) =>
  useChatsImpl(options);
